import React from 'react';
import { Cashback } from '../../types';
import { editButton } from '../../assets/svg';
import numeral from 'numeral';
import { naira } from '../../constants';
import { PrimaryButton } from './shared';

interface CashbackCardProps {
  cashback: Cashback;
  edit: () => void;
  onClick?: () => void;
}

export const CashbackCard = ({
  cashback,
  edit,
  onClick,
}: CashbackCardProps) => {
  return (
    <div className="header1">
      <div className="border w-full rounded-lg border-neutral-600 p-4">
        <div className="flex justify-between items-center py-2 border-b border-neutral-600">
          <h1 className="bold text-xl">Cashback</h1>
          <div className="flex gap-4">
            <PrimaryButton
              text="see transactons"
              onClick={() => onClick && onClick()}
            />
            <button onClick={() => edit()}>
              <img src={editButton} alt="edit-button" />
            </button>
          </div>
        </div>

        {cashback ? (
          <div className="grid grid-cols-2 gap-2 mt-4">
            <React.Fragment key={cashback.id ?? 0}>
              <div>
                <p className="uppercase bold">Description</p>
                <div className="border border-neutral-300 px-2 py-4 rounded mt-2">
                  <p>{cashback?.description ?? '-'}</p>
                </div>
              </div>

              <div>
                <p className="uppercase bold">Percentage</p>
                <div className="border border-neutral-300 px-2 py-4 rounded mt-2">
                  <p className="uppercase">{cashback.percentage}% cashback</p>
                </div>
              </div>

              <div>
                <p className="uppercase bold">Active?</p>
                <div className="border border-neutral-300 px-2 py-4 rounded mt-2">
                  <p className="uppercase">
                    {cashback.isActive ? 'YES' : 'NO'}
                  </p>
                </div>
              </div>

              <div>
                <p className="uppercase bold">Flat amount</p>
                <div className="border border-neutral-300 px-2 py-4 rounded mt-2">
                  <p className="uppercase">
                    {`${naira}${numeral(cashback.flatAmount).format('0,0')}`}
                  </p>
                </div>
              </div>
            </React.Fragment>
          </div>
        ) : (
          <p className="mt-4">No cashback exists</p>
        )}
      </div>
    </div>
  );
};
